import Model, { attr } from '@ember-data/model';

import type { APIData, DateRangeInterface, DSSetup } from 'webapp-types';
import { ForecastComparisonPeriod, TimeUnit } from 'webapp/enums/enums';

import type { ForecastMethodology } from 'webapp/models-custom/forecast';
import type { RegressorMetricData } from 'webapp/models-custom/regressor-metric';

export default class ForecastRecord extends Model {
	@attr('number') blockId!: number; // used to match with sample
	@attr('object') forecastDateRange!: DateRangeInterface.FormulaInterface;
	@attr('object') historyDateRange!: DateRangeInterface.FormulaInterface; // only used when going from saved to explorer
	@attr('object-or-null') timeframe!: { type: number; year: number } | null;
	@attr('string') endDate!: string | null;

	@attr('string') metricSetupKey!: string;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;

	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	seasonality!: TimeUnit[];

	@attr('string') holidaysCountry!: string | null;

	@attr('number') created!: number;
	@attr('number') createdBy!: number;
	@attr('number') order!: number | null;

	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	tags!: number[];

	@attr('object') methodology!: ForecastMethodology;
	@attr('number', { defaultValue: TimeUnit.MONTH }) granulation!: TimeUnit;
	@attr('string', { defaultValue: ForecastComparisonPeriod.PREVIOUS_PERIOD })
	comparisonPeriod!: ForecastComparisonPeriod;
	@attr('string') title!: string | null;

	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	regressors!: RegressorMetricData[];

	@attr('number') lastSnapshotId!: number | null;
	@attr('object-or-null') statusObject!: APIData.Forecast.StatusObject | null;
}
